module.exports = __webpack_public_path__ + "static/img/weiguanwang.4d6cf47.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/weiguanwang.png
// module id = 9OQk
// module chunks = 52